import { createAction } from 'redux-actions';
import * as Api from 'api/conversations';
import { destroyNewConversationPlaceholder } from './ui';
import { history } from 'store';

const requestPostConversationMessage = createAction(
  'POST_CONVERSATION_MESSAGE_REQUEST',
);
const receivePostConversationMessage = createAction(
  'POST_CONVERSATION_MESSAGE_SUCCESS',
);
const failPostConversationMessage = createAction(
  'POST_CONVERSATION_MESSAGE_ERROR',
);

export const postConversationMessage = (conversationId, body) => dispatch => {
  dispatch(requestPostConversationMessage(conversationId, body));

  return Api.postConversationMessage(conversationId, body).then(
    data => {
      dispatch(receivePostConversationMessage({ conversationId, data }));
    },
    error => dispatch(failPostConversationMessage(error)),
  );
};

const requestConversation = createAction('CONVERSATION_REQUEST');
const receiveConversation = createAction('CONVERSATION_SUCCESS');
const failConversation = createAction('CONVERSATION_ERROR');

export const getConversation = id => dispatch => {
  dispatch(requestConversation(id));

  return Api.getConversation(id).then(
    response => dispatch(receiveConversation(response)),
    error => dispatch(failConversation(error)),
  );
};

const requestArchiveConversation = createAction('ARCHIVE_CONVERSATION_REQUEST');
const receiveArchiveConversation = createAction('ARCHIVE_CONVERSATION_SUCCESS');
const failArchiveConversation = createAction('ARCHIVE_CONVERSATION_ERROR');

export const archiveConversation = id => dispatch => {
  dispatch(requestArchiveConversation(id));

  return Api.archiveConversation(id).then(
    response => dispatch(receiveArchiveConversation(response)),
    error => dispatch(failArchiveConversation(error)),
  );
};

const requestUpdateConversationLastReadMessage = createAction(
  'UPDATE_CONVERSATION_LAST_READ_MESSAGE_REQUEST',
);
const receiveUpdateConversationLastReadMessage = createAction(
  'UPDATE_CONVERSATION_LAST_READ_MESSAGE_SUCCESS',
);
const failUpdateConversationLastReadMessage = createAction(
  'UPDATE_CONVERSATION_LAST_READ_MESSAGE_ERROR',
);

export const updateConversationLastReadMessage = ({
  conversationId,
  messageId,
}) => dispatch => {
  dispatch(requestUpdateConversationLastReadMessage(conversationId));

  return Api.updateConversationLastReadMessage({
    conversationId,
    messageId,
  }).then(
    response => dispatch(receiveUpdateConversationLastReadMessage(response)),
    error => dispatch(failUpdateConversationLastReadMessage(error)),
  );
};

const requestConversationMessages = createAction(
  'CONVERSATION_MESSAGES_REQUEST',
);
const receiveConversationMessages = createAction(
  'CONVERSATION_MESSAGES_SUCCESS',
);
const failConversationMessages = createAction('CONVERSATION_MESSAGES_ERROR');

export const getConversationMessages = conversationId => dispatch => {
  dispatch(requestConversationMessages(conversationId));

  return Api.getConversationMessages(conversationId).then(
    data => {
      dispatch(receiveConversationMessages({ conversationId, data }));
      dispatch(
        updateConversationLastReadMessage({
          conversationId,
          messageId: data.result[0],
        }),
      );
    },
    error => dispatch(failConversationMessages(error)),
  );
};

const requestCreateConversation = createAction('NEW_CONVERSATION_REQUEST');
const receiveCreateConversation = createAction('NEW_CONVERSATION_SUCCESS');
const failCreateConversation = createAction('NEW_CONVERSATION_ERROR');

export const createConversation = (
  placeId,
  conversation,
  message,
) => dispatch => {
  dispatch(requestCreateConversation());

  return Api.postConversation(placeId, conversation).then(
    res => {
      const conversationId = res.result;
      dispatch(receiveCreateConversation(res));
      dispatch(postConversationMessage(conversationId, message)).then(() => {
        dispatch(destroyNewConversationPlaceholder());
        history.push(`/mes-echanges/mes-messages/${conversationId}`);
      });
    },
    error => dispatch(failCreateConversation(error)),
  );
};

const requestUpdateConversation = createAction('UPDATE_CONVERSATION_REQUEST');
const receiveUpdateConversation = createAction('UPDATE_CONVERSATION_SUCCESS');
const failUpdateConversation = createAction('UPDATE_CONVERSATION_ERROR');

export const updateConversation = (
  conversationId,
  conversation,
) => dispatch => {
  dispatch(requestUpdateConversation());

  return Api.putConversation(conversationId, conversation).then(
    result => dispatch(receiveUpdateConversation(result)),
    error => dispatch(failUpdateConversation(error)),
  );
};

const requestUpdateConversationDisplayName = createAction(
  'UPDATE_CONVERSATION_DISPLAY_NAME_REQUEST',
);
const receiveUpdateConversationDisplayName = createAction(
  'UPDATE_CONVERSATION_DISPLAY_NAME_SUCCESS',
);
const failUpdateConversationDisplayName = createAction(
  'UPDATE_CONVERSATION_DISPLAY_NAME_ERROR',
);

export const updateConversationDisplayName = (
  conversationId,
  payload,
) => dispatch => {
  dispatch(requestUpdateConversationDisplayName());

  return Api.putConversationDisplayName(conversationId, payload).then(
    result => dispatch(receiveUpdateConversationDisplayName(result)),
    error => dispatch(failUpdateConversationDisplayName(error)),
  );
};
